import fetch from 'auth/FetchInterceptor'

const financeiroService = {}

financeiroService.saldo = function () {
  return fetch({
    url: '/financeiro/saldo',
    method: 'get',
    headers: {
        'Content-Type': 'application/json',
      },
  })
}

financeiroService.baixar = function (data) {
  return fetch({
    url: `/financeiro/${data}/baixar-saldo`,
    method: 'post',
    data: data
  })
}

financeiroService.extratoPaginado = function ({ inicio, fim, tipoMovimento, categorias = [], page = 0, size = 10 } = {}) {
  const params = { page, size }
  if (inicio) params.inicio = inicio
  if (fim) params.fim = fim
  if (tipoMovimento) params.tipoMovimento = tipoMovimento
  if (categorias && categorias.length) params.categorias = categorias.join(',')
  return fetch({
    url: '/financeiro/extrato',
    method: 'get',
    params,
  })
}

financeiroService.categorias = function () {
  return fetch({
    url: '/financeiro/extrato/categorias',
    method: 'get',
  })
}

export default financeiroService
